import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '../../components/PrimereactComponents';
import AnalysesNavList from '../../components/analysesNav/AnalysesNavList';
import ContentSection from '../../components/common/ContentSection/ContentSection';

function Analyses() {
    const { t } = useTranslation(['analyses']);

    return (
        <>
            <ContentSection title={t('analysesTitle')} level={1} subtitle={t('analysesTitleTooltip')} className='page-title-section' />
            <Tooltip target='.custom-target-icon' />
            <AnalysesNavList variant='analyses' />
            <Outlet />
        </>
    );
}

export default Analyses;
